import { useContext } from 'react';
import { WizardContext } from '../wizard/WizardContext';
import IdVerificationContext from '../IdvContext';
import { useIsFetching, useIsMutating } from '@zg-rentals/react-query5';
import { Box, LoadingMask, Modal, ToastProvider } from '@zillow/constellation-10';
import Header from './Header';
import InitializeWizard from './InitializeWizard';
import Footer from './Footer';

export function WizardContent() {
  const { currentStep } = useContext(WizardContext);
  const { hasInitializedWizard, isOnExitLoading } = useContext(IdVerificationContext);
  const isFetching = useIsFetching();
  const isMutating = useIsMutating();
  const isWizardLoading = !hasInitializedWizard || isFetching || isMutating || isOnExitLoading;

  return (
    <Modal
      open
      size="fullScreen"
      useDismissProps={{ escapeKey: false, outsidePress: false }}
      closeButton={null}
      css={{
        overflow: 'hidden',
        height: '100%',
        '& > [data-c11n-component=Modal\\.Header]': {
          paddingInline: 'default',
        },
      }}
      header={<Header />}
      body={
        <ToastProvider>
          <LoadingMask loading={Boolean(isWizardLoading)} css={{ display: 'block', minHeight: '100%' }}>
            <Box
              css={{
                display: 'grid',
                gridTemplateColumns: 'repeat(24, 1fr)',
                height: '100%',
              }}
            >
              <Box
                css={{
                  gridColumnEnd: { lg: 'span 2' },
                  display: { base: 'none', lg: 'block' },
                }}
              />
              <Box
                css={{
                  display: 'grid',
                  gridColumnEnd: { base: 'span 24', lg: 'span 20' },
                }}
              >
                <Box css={{ marginTop: { lg: 'default' }, marginBottom: { base: 'default', lg: 'loose' } }}>
                  {!hasInitializedWizard ? <InitializeWizard /> : <currentStep.Component />}
                </Box>
              </Box>
              <Box
                css={{
                  gridColumnEnd: { lg: 'span 2' },
                  display: { base: 'none', lg: 'block' },
                }}
              />
            </Box>
          </LoadingMask>
        </ToastProvider>
      }
      footer={<Footer isWizardLoading={Boolean(isWizardLoading)} />}
    />
  );
}
